import {
    FILE_COLUMNS as COLUMNS,
    ID_TYPE,
    TABLE_NAMES,
    TABLE_NAMES_WITH_FILTERS,
    usePermissions
} from "shared";

import EditFileInline from "../Actions/dialogs/Files/Inline/EditFile";
import { useFileInlineActions } from "../Actions/InlineActions";
import MainContainer from "../MainContainer";
import Table from "../Table";

const Files = () => {
    const { isReadFileNotAllowed } = usePermissions();

    const { inlineActions, rowData, isOpen, closeDialog } =
        useFileInlineActions();

    return (
        <>
            <MainContainer>
                <Table
                    name={TABLE_NAMES.Files}
                    nameForFilters={TABLE_NAMES_WITH_FILTERS.Files}
                    hasNoPermissionToRead={isReadFileNotAllowed}
                    initialColumns={COLUMNS}
                    inlineActions={inlineActions}
                    idType={ID_TYPE.Id}
                    sortFromNewest
                    hasActionBar
                />
            </MainContainer>

            <EditFileInline
                data={rowData}
                isOpen={isOpen}
                close={closeDialog}
            />
        </>
    );
};

export default Files;
